import { Box } from '@mui/material';
import { AuditMatch } from '../../types';
import { BcrMatchStatus } from './BcrMatchStatus';
import { ConfirmedBySchedule } from './ConfirmedBySchedule';
import { ManualMatchIndicator } from './ManualMatchIndicator';

export function MatchStatuses(p: { match: AuditMatch }) {
  return (
    <Box display="flex" gap={1} alignItems="center">
      {p.match.source === 'MANUAL' && <ManualMatchIndicator />}
      {p.match.matchedSchedule && (
        <ConfirmedBySchedule
          schedule={p.match.matchedSchedule}
          confirmationType={p.match.matchedScheduleConfirmationType}
          matchDatetime={p.match.datetime}
          diffMinutes={p.match.matchedScheduleDiff}
          schedulesListCategory="spot"
        />
      )}
      <BcrMatchStatus match={p.match} />
    </Box>
  );
}
